import React, { useContext } from 'react';
import athlete_skeleton from './athlete_skeleton.png';
import { AppContext } from '../../App';
import { motion } from 'framer-motion';
import { CountryFlag } from '../../Utils/flags';
import { getCrosslinkClass, handleClickAthleteName } from '../../Utils/crosslink';
import { CosmosImage } from '../../cosmos/web-scoped/react';

const Athlete = ({
  index,
  result,
  // heat,
  // showResultsPast,
  config,
  athlete,
  showAthleteImage = true,
  crosslinkDetails
}) => {
  const appConfig = useContext(AppContext).config;
  const context = useContext(AppContext);
  const { animation } = appConfig;
  const itemAnimation = {
    hidden: {
      y: 20,
      opacity: 0,
      transition: {
        duration: animation.duration,
        ease: animation.ease
      }
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: animation.duration,
        ease: animation.ease
      }
    }
  };

  const { score, rank } = result;

  return (
    <motion.tr
      className={`${index % 2 === 0 ? 'odd' : 'even'}`}
      variants={itemAnimation}
      style={!athlete.last_name && { display: 'none' }}
      positionTransition
    >
      {rank ? (
        <td className={`rank font-bold nowrap text-center font-mono`}>{rank}.</td>
      ) : (
        <td style={{ width: 0 }}></td>
      )}
      {showAthleteImage && (
        <td
          onClick={(e) => {
            handleClickAthleteName(e, athlete.id, crosslinkDetails);
          }}
          className={`athleteImage ${getCrosslinkClass(context, crosslinkDetails)}`}
        >
          <div>
            <CosmosImage
              image={
                athlete.image
                  ? athlete.image.profile || athlete_skeleton
                  : athlete_skeleton
              }
              image-preview={athlete_skeleton}
              image-alt={`image-${athlete.first_name}-${athlete.last_name}`}
            />
          </div>
        </td>
      )}
      <td className={`gate nowrap${!result.gate ? ' empty' : ''}`}>
        {!result.gate || `G${result.gate}`}
      </td>
      <td
        onClick={(e) => {
          handleClickAthleteName(e, athlete.id, crosslinkDetails);
        }}
        className={`nationality ${getCrosslinkClass(context, crosslinkDetails)}`}
      >
        <img
          className="flag"
          src={CountryFlag(athlete.nationality.iso3)}
          alt={athlete.nationality.iso3}
        />
      </td>
      <td
        className={`${config.leaveNamesCapitalization ? '' : 'text-capitalize '}fullname`}
      >
        <span
          onClick={(e) => {
            handleClickAthleteName(e, athlete.id, crosslinkDetails);
          }}
          className={`${getCrosslinkClass(context, crosslinkDetails)}`}
        >
          {config.leaveNamesCapitalization ? (
            <>
              {athlete.first_name && (
                <>
                  {athlete.first_name}
                  <br />
                </>
              )}
              {athlete.last_name}
            </>
          ) : (
            <>
              {athlete.first_name.toLowerCase()} {athlete.last_name.toLowerCase()}
            </>
          )}
        </span>
      </td>
      <td
        className="info font-mono nowrap text-right"
        dangerouslySetInnerHTML={{ __html: score }}
      ></td>
    </motion.tr>
  );
};

export { Athlete };
